import { render, staticRenderFns } from "./CmgCheckoutOrderPickupPreference.vue?vue&type=template&id=8dd68e74&scoped=true&lang=pug&"
import script from "./cmg-checkout-order-pickup-preference.ts?vue&type=script&lang=ts&"
export * from "./cmg-checkout-order-pickup-preference.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCheckoutOrderPickupPreference.vue?vue&type=style&index=0&id=8dd68e74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd68e74",
  null
  
)

export default component.exports